import { FC } from 'react';

import Link from 'next/link';

import styles from './RightColumnDetailLinks.module.scss';

type Props = {
  roomId: string;
  company: {
    id: string;
    name: string;
  };
};

const RightColumnDetailLinksInCompany: FC<Props> = ({ roomId, company }) => {
  return (
    <>
      <div className={styles.container}>
        <Link href={`/console/admin/chat/company_contact?roomId=${roomId}`} passHref>
          <a className={styles.contact_btn}>運営問い合わせ</a>
        </Link>
        <Link href={`/console/admin/chat/talk?company_id=${company.id}&company_name=${company.name}`} passHref>
          <a className={styles.chat_btn}>売却相談チャット</a>
        </Link>
        <Link href={`/console/admin/sale_cases?company_id=${company.id}`} passHref>
          <a className={styles.sale_cases_btn}>売却実績一覧</a>
        </Link>
      </div>
    </>
  );
};

export default RightColumnDetailLinksInCompany;
